export const PATHS = {
  ROOT: 'part-time-job-dates',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
  partTimeJobId: (partTimeJobId: number) =>
    `/part-time-jobs/${partTimeJobId}/${PATHS.ROOT}`,
  bulk: (partTimeJobId: number) =>
    `/part-time-jobs/${partTimeJobId}/${PATHS.ROOT}`,
};
